export default __webpack_public_path__ + "static/media/undo.9ddc7ae7.mp3";